import React from "react";
import favicon from "../assets/favicon.png";

// Shown while a page's real content is being fetched from the DB, instead of a blank flash or
// stale/static placeholder text. Same visual language as the rest of the site (navy background,
// floating-light glow orbs) so it reads as part of the site, not a generic spinner screen.
export default function PageLoader() {
  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-navy overflow-hidden">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="floating-light absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-accent/20 blur-[120px]" style={{ animationDuration: "18s" }} />
        <div className="floating-light absolute -bottom-40 -right-20 w-[500px] h-[500px] rounded-full bg-accent-light/10 blur-[120px]" style={{ animationDuration: "22s", animationDelay: "2s" }} />
        <div className="floating-light absolute top-1/3 left-1/2 w-[350px] h-[350px] rounded-full bg-purple-500/10 blur-[100px]" style={{ animationDuration: "26s", animationDelay: "4s" }} />
      </div>

      <div className="relative flex flex-col items-center gap-6">
        <div className="relative flex items-center justify-center w-24 h-24">
          <span className="absolute inset-0 rounded-full border-2 border-navy-border border-t-accent-light animate-spin" />
          <img src={favicon} alt="Loading" className="w-12 h-12 object-contain animate-pulse" />
        </div>
        <p className="gradient-text-animated text-lg font-semibold tracking-wide">
          Loading...
        </p>
      </div>
    </div>
  );
}
